import { lazy } from 'react';

export const CustomersList = lazy(() => import('./pages/CustomersList'));
export const CustomerDetail = lazy(() => import('./pages/CustomerDetail'));
export const CustomerNew = lazy(() => import('./pages/CustomerNew'));
export const CorporateCustomerNew = lazy(() => import('./pages/CorporateCustomerNew'));
export const CorporateCustomerDetail = lazy(() => import('./pages/CorporateCustomerDetail'));

export { CUSTOMER_ROUTES } from './paths';
